import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouteNavigationService } from '../route-navigation.service';
import { Store } from '@ngxs/store';
import { ApplicationStateModel, selectAppStateSnapshot, StoreState } from '../../../app.state';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';

@Injectable()
export class HasCompanyRouteGuard {
  constructor(private _store: Store,
              private _authenticationService: AuthenticationService,
              private _routeNavigationService: RouteNavigationService) {

  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._authenticationService.isInitialized$
      .pipe(
        filter(_ => _),
        map(_ => {
          const applicationState = selectAppStateSnapshot(this._store);

          if (!applicationState.company) {
            this._routeNavigationService.goToCompanyCreationAsync();
          }

          return !!applicationState.company;
        }),
      );
  }
}
